import React, { Component } from "react"
import Collapsible from 'react-collapsible';
import axios from 'axios';
import _ from 'lodash';
import date from "../node_modules/date-and-time";
import store from "./store/index";
import { updateCurrentRaceTime } from "./actions/index";
import { updateAllCountryList } from "./actions/index";
import moment from 'moment';
import ReactCountryFlag from "react-country-flag";


const API = 'https://rpmapigreyhound.makebettinggreat.com/v1/greyhound/events/';

const fontStyle1 = {
  color: 'white'
};

const style345 = {
  marginLeft: '15px'
}

const headStyle1 = {
  color: '#36486b',
  textAlign: 'center',
  fontSize: '14px',
  fontfamily: 'Roboto',
  paddingTop: '10px'
}

const eventButtonStyle = {
  height: '30px',
  padding: '0px 0px 0px 10px'
}

class CollapsibleList extends Component {
  firstNotStartedEventFound = false;

  constructor(props) {
    super(props);

    this.state = {
      hits: [
        { objectID: '1', url: 'https://blog.com/hello', title: 'hello', },
        { objectID: '2', url: 'https://blog.com/there', title: 'there', },
      ],
      racesByCountryNow: [],
      selectedDate: this.props.selectedDate
    };

    this.raceEventElementRef = React.createRef();
  }

  fetchEventsFromBackend = queryDate => {
    var th = this;
    //console.log("TIME EX ::" + (API + queryDate));
    //console.log("Local time ::> " + moment().utcOffset(store.getState().localTimeOffSetToGmt).format('YYYYMMDD HH:mm'));

    this.serverRequest =
      axios.get(API + queryDate)
        .then(function (result) {

          const Array = result.data;
          window.rawArray = Array
          const Property = "bfCountry";
          const playersByTeam = _.groupBy(Array, Property);

          //console.log("Players By team" + playersByTeam);
          //console.log("hhh " + Object.keys(playersByTeam));
          store.dispatch(updateAllCountryList(Object.keys(playersByTeam)))
          //console.log("TEAMS :::: " + Object.keys(playersByTeam));

          Object.keys(playersByTeam).map(item => {
            if (store.getState().filteredCountryList.includes(item)) { }
            else { //delete playersByTeam[item]
            }
          }
          )

          Object.keys(playersByTeam).map(item => { playersByTeam[item].sort((a, b) => ((a.bfTime > b.bfTime) && (a.bfDate == b.bfDate) || ((a.bfDate > b.bfDate))) ? 1 : -1) }
          )

          th.setState({
            hits: result.data,
            racesByCountryNow: playersByTeam,
          });
          //console.log(result);
          window.racesByCountryNow = playersByTeam


        })
  }

  componentDidMount() {
   // console.log("CollapsibleList:: - componentDidMount")
    let queryDate = this.state.selectedDate; //Date YYYY in UK Time
    this.fetchEventsFromBackend(queryDate)
    // let now = new Date();
    // let queryDate = date.format(now, 'YYYYMMDD', true); //Date YYYY in UK Time
  }

  loadTable = ele => {

    var currentRace = { marketInfoMarketId: ele.marketInfoMarketId, marketWinnerCount: ele.marketWinnerCount,time: ele.bfTime, date: ele.bfDate, venue: ele.bfVenue, marketId: ele.bfMarketId, marketName: ele.bfMarketName }
    //console.log("Venue :" + ele.bfVenue + " Time :" + ele.bfTime + " Country :" + ele.bfCountry);
    //console.log("current racers :: " + ele.runners)
    let dateString = ele.bfDate + " " + ele.bfTime
    //console.log("CURRENT RACE MOMENT :: " + dateString);

    let date = moment(dateString, 'YYYYMMDD HH:mm').format('YYYYMMDD HH:mm');
    //console.log("CURRENT RACE MOMENT :: " + date);

    store.dispatch(updateCurrentRaceTime(date))

    //console.log(this.props.updateBoards);
    this.props.updateBoards(currentRace, ele.runners);
  }

  componentDidUpdate(prevProps) {
    //console.log("CollapsibleList:: - componentDidUpdate")

    if(this.props.selectedDate !== prevProps.selectedDate) {
      let queryDate = this.props.selectedDate; //Date YYYY in UK Time
      this.fetchEventsFromBackend(queryDate)
      this.setState({
        selectedDate: this.props.selectedDate
      })
    }

    if(this.raceEventElementRef.current !== null) {
      this.raceEventElementRef.current.click();
    }
  }

  render() {
    var newOb = {}

    Object.keys(this.state.racesByCountryNow).map(item => {
      if (store.getState().filteredCountryList.includes(item)) {
        newOb[item] = this.state.racesByCountryNow[item]
      }
      else { //delete playersByTeam[item]
      }
    })

    if(this.state.hits.length > 0) {
      //console.log(this.state.hits[0].bfDate);
      //console.log("HUHU " + this.state.racesByCountryNow["GBR"]);
    }
   
    //console.log(this.state);
   

    //this.loadTable(newOb[0][0])

    return (

      <div class="divStyle1 borderStyle">
        <p style={headStyle1}><strong>Countries</strong></p>
        <div class="blockSize blockSpacing" style={fontStyle1} >
          {
            
            Object.keys(newOb).map(item => {
              const collapsibleKey = item;
              return(
                <Collapsible 
                  key={collapsibleKey}
                  open={true} 
                  trigger={
                  <div class="countryTabDiv">
                    <ReactCountryFlag code={item} styleProps={{
                      width: '30px',
                      height: '30px',
                      marginLeft: '10px'
                    }} svg />
                    <span style={style345}>{store.getState().fullCountryName[item]}</span>
                  </div>} class="borderText">
                  <div>
                    <div class="list-group" id={store.getState().fullCountryName[item]}>
                      {newOb[item].map(innerEle => {
                        const key = innerEle.bfCountry + "-" + innerEle["bfVenue"] + "-" + moment((innerEle.bfDate + " " + innerEle.bfTime), 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes').format('HH:mm');
                        const raceAlreadyStarted = moment().utcOffset(store.getState().localTimeOffSetToGmt).format("YYYYMMDDHHmm") > moment((innerEle.bfDate + " " + innerEle.bfTime), 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes').format("YYYYMMDDHHmm")
                        let button = <button type="button" 
                                              key={key}
                                              style={eventButtonStyle}
                                              class={"list-group-item list-group-item-action " +  (raceAlreadyStarted ? 'kfjdkf' : 'kfjdkfGrey')} onClick={() => this.loadTable(innerEle)} >
                                              {innerEle["bfVenue"]} - {moment((innerEle.bfDate + " " + innerEle.bfTime), 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes').format('HH:mm')} {innerEle.bfCountry === "AU" ? innerEle.bfMarketName.split(" ")[0] :  null}
                                              </button>
                        if(!raceAlreadyStarted && !this.firstNotStartedEventFound && this.raceEventElementRef.current === null) {
                          this.firstNotStartedEventFound = true;
                          button = <button type="button" 
                                              key={key}
                                              style={eventButtonStyle}
                                              ref={this.raceEventElementRef}
                                              class={"list-group-item list-group-item-action " +  (raceAlreadyStarted ? 'kfjdkf' : 'kfjdkfGrey')} onClick={() => this.loadTable(innerEle)} >
                                              {innerEle["bfVenue"]} - {moment((innerEle.bfDate + " " + innerEle.bfTime), 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes').format('HH:mm')} {innerEle.bfCountry === "AU" ? innerEle.bfMarketName.split(" ")[0] :  null}
                                              </button>
                          //console.log("First not started event found: " + key);
                        }
                        return(
                         button
                        )
                      }                    
                      )}
                    </div>
                  </div>
                </Collapsible>
              );
            }
            )
          }
        </div>
      </div>
    )
  }
}

export default CollapsibleList;
